import React, { useEffect, useState } from "react";
import "../../assets/styles/components/_login.scss";
import logo from "../../assets/images/brand/Tensolite-Isologotipo-blanco.png";
import useForm from "../../hooks/useForm";
import { toast } from "react-hot-toast";
import useCliente from "../../hooks/useCliente";
import { useParams } from "react-router-dom";
import { SpinnerCircular } from 'spinners-react';
import passwordIcon from "../../assets/images/icons/CONTRASENA.svg"
import eyeIcon from "../../assets/images/icons/OJO.svg"

const NewPassword = () => {
  const { values, handleInputChange } = useForm({
    newFirstPassword: "",
    newSecondPassword: "",
  });
  const [errorNotMatchPassword, setErrorNotMatchPassword] = useState(false);

  const [inputError, setInputError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showPasswordFirst, setShowPasswordFirst] = useState(false);
  const [showPasswordSecond, setShowPasswordSecond] = useState(false);
  const [userToChangePassword, setUserToChangePassword] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useParams();



  const { changeOldPassword, getUserToChangePassword } = useCliente();

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await getUserToChangePassword(token);
        if (response.success) {
          setUserToChangePassword(response);
        } else {
          toast.error("Error al obtener los datos del usuario", {
            duration: 1500,
          });
        }
      } catch (error) {
        toast.error(error, {
          duration: 1500
        })
      }
      finally {
        setLoading(false);
      }
    }
    getUser();
  }, []);

  const MostrarMensajeError = (event, message) => {
    const toastMessage = message ? message : "Las contraseñas no coinciden";
    toast.error(toastMessage, {
      duration: 1500,
    });
    event.preventDefault();
  };

  const VerificarCampos = (event) => {
    event.preventDefault();

    if (
      values.newFirstPassword.length < 6 ||
      !/[A-Z]/.test(values.newFirstPassword) ||
      !/[0-9]/.test(values.newFirstPassword)
    ) {
      setPasswordError(true);
      MostrarMensajeError(
        event,
        "La contraseña debe tener al menos 6 caracteres, una letra mayúscula y un número. Ademas la contraseña debe tener entre 6 y 12"
      );
      return;
    }

    if (values.newFirstPassword === values.newSecondPassword) {
      const userInfo = {
        newPassword: values.newFirstPassword,
        email: userToChangePassword.userEmail,
        role: userToChangePassword.userRole,
        userId: userToChangePassword.userId,
      };
      changeOldPassword(userInfo);
    } else {
      setErrorNotMatchPassword(true);
      MostrarMensajeError(event, "Las contraseñas no coinciden.");
    }

    if (values.newFirstPassword === "" || values.newSecondPassword === "") {
      setInputError(true);
    }
  };

  const toggleShowPasswordFirst = () => {
    setShowPasswordFirst(!showPasswordFirst);
  };
  const toggleShowPasswordSecond = () => {
    setShowPasswordSecond(!showPasswordSecond);
  };

  return (
    <>
      <form className="container login__card-form allBorderRadius" onSubmit={VerificarCampos}>
        <div className="logo-login">
          <img src={logo} alt="Logo Tensolite" className="logo" />
        </div>
        {
          loading ? (
            <SpinnerCircular color="#ffffff" />
          ) : userToChangePassword && userToChangePassword.success ? (
            <div className="flex-col">
              <div className="flex-col">
                <p className="textFooterLogin">
                  Ingrese su nueva contraseña
                </p>
                <div className={`inputNoEye ${errorNotMatchPassword || inputError || passwordError
                  ? "input-error"
                  : ""
                  }`}>
                  <img src={passwordIcon} alt="passwordIcon" className="inputIcon" />
                  <input
                    maxLength={12}
                    type={showPasswordFirst ? "text" : "password"}
                    id="newFirstPassword"
                    name="newFirstPassword"
                    className="inputLogin"
                    placeholder="Nueva contraseña"
                    value={values.newFirstPassword}
                    onChange={handleInputChange}
                  />
                  <img src={eyeIcon} alt="eyeIcon" className="inputIcon eyeIcon" onClick={toggleShowPasswordFirst} />

                </div>
              </div>
              <div className={`inputNoEye ${errorNotMatchPassword || inputError || passwordError
                ? "input-error"
                : ""
                }`}>
                <img src={passwordIcon} alt="passwordIcon" className="inputIcon" />
                <input
                  maxLength={12}
                  type={showPasswordSecond ? "text" : "password"}
                  id="newSecondPassword"
                  name="newSecondPassword"
                  className="inputLogin"
                  placeholder="Ingrese su Nueva Contraseña"
                  value={values.newSecondPassword}
                  onChange={handleInputChange}
                />
                <img src={eyeIcon} alt="eyeIcon" className="inputIcon eyeIcon" onClick={toggleShowPasswordSecond} />
              </div>
              <input
                type="submit"
                className="button--submit mt-3"
                value="CAMBIAR CONTRASEÑA"
              />
            </div>
          ) : (
            <div className="flex-col">
              <p className="userNotFound">Usuario no encontrado o contraseña ya cambiada</p>
            </div>
          )
        }

      </form>
    </>
  );
};

export default NewPassword;
